import React from 'react';

import PropTypes from 'prop-types';

const Button = ({ label, onClick, type, disabled, direction }) => {
  const buttonClasses = direction === 'forward' ? 'btn' : 'btn -backward';
  return (
    <button
      className={buttonClasses}
      // eslint-disable-next-line react/button-has-type
      type={type || 'button'}
      disabled={disabled}
      onClick={onClick}>
      {direction === 'backward' && <span className="backward-icon" />}
      {label}
      {direction === 'forward' && <span className="forward-icon" />}
    </button>
  );
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  onClick: () => { },
  direction: 'null',
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  direction: PropTypes.string,
};

export default Button;
